

require('./directive');

var _squid = require('squid');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$SelectCardRoute', function () {
    return _squid.$ComponentRoute.extend('SelectCardRoute', {

        name: 'selectCard',
        directive: 'xo-select-card',
        titleContent: 'asideHeader.selectCard',
        children: []
    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/selectcard/route.js
// module id = ../node_modules/xo-wallet-components/src/add-card/selectcard/route.js
// module chunks = 0